import React, { Component } from "react"
import Carousel from "react-multi-carousel"
import "./style.scss"
import arrowLeft from "../../images/arrowleft.svg"
import arrowRight from "../../images/arrowright.svg"
class Scrollbar extends Component {
  state = { additionalTransfrom: 0 }
  render() {
    const CustomSlider = ({ carouselState }) => {
      let value = 0
      let carouselItemWidth = 0
      if (this.Carousel) {
        carouselItemWidth = this.Carousel.state.itemWidth
        const maxTranslateX = Math.round(
          // so that we don't over-slide
          carouselItemWidth *
            (this.Carousel.state.totalItems -
              this.Carousel.state.slidesToShow) +
            150
        )
        value = maxTranslateX / 100 // calculate the unit of transform for the slider
      }
      const { transform } = carouselState
      return (
        <div className="custom-slider">
          <input
            type="range"
            value={Math.round(Math.abs(transform) / value)}
            // defaultValue={0}
            max={
              (carouselItemWidth *
                (carouselState.totalItems - carouselState.slidesToShow) +
                (this.state.additionalTransfrom === 150 ? 0 : 150)) /
              value
            }
            onChange={e => {
              if (this.Carousel.isAnimationAllowed) {
                this.Carousel.isAnimationAllowed = false
              }
              const nextTransform = e.target.value * value
              const nextSlide = Math.round(nextTransform / carouselItemWidth)
              if (
                e.target.value === 0 &&
                this.state.additionalTransfrom === 150
              ) {
                this.Carousel.isAnimationAllowed = true
                this.setState({ additionalTransfrom: 0 })
              }
              this.Carousel.setState({
                transform: -nextTransform, // padding 20px and 5 items.
                currentSlide: nextSlide,
              })
            }}
            className="custom-slider__input"
          />
        </div>
      )
    }
    const CustomRightArrow = ({ onClick }) => (
      <img
        className="custom_right_arrow"
        onClick={() => onClick()}
        onKeyDown={() => onClick()}
        alt="right"
        src={arrowRight}
      />
    )
    const CustomLeftArrow = ({ onClick }) => (
      <img
        className="custom_left_arrow"
        onClick={() => onClick()}
        onKeyDown={() => onClick()}
        alt="left"
        src={arrowLeft}
      />
    )
    return (
      <Carousel
        arrows={true}
        ref={el => (this.Carousel = el)}
        customButtonGroup={<CustomSlider />}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<CustomLeftArrow />}
        itemClass="image-item"
        responsive={this.props.testimonialProperties}
        containerClass="carousel-container-with-scrollbar"
      >
        {this.props.children}
      </Carousel>
    )
  }
}
export default Scrollbar
